import React, { useEffect, useState } from "react";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  // @ts-ignore
} from "../../../components/ui/select";
// @ts-ignore
import { useDropdownData } from "../../Services/Common.tsx";
import { useInvitationManagement } from "../../Services/InvitationManagement";
import { useUserContext } from "../../../Contexts/UserProvider";
import { toast } from "react-toastify";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetFooter } from "../../../components/ui/sheet"
import {
  User2,
  Loader2
} from "lucide-react"
import { inputFieldValidator } from "../../../Utilities/validation";
import { usePermissionManagement } from "../../Services/PermissionManagement";
import { useGlobalUsers } from "../../Services/UserManagement";

const InviteUser = (props) => {
  const [inviteUserDetails, setInviteUserDetails] = useState({
    userType: undefined,
    roleId: undefined,
    email: undefined,
    firstname: undefined,
    lastname: undefined,
  });
  const [loading, setLoading] = useState(false);
  const { userManagemnetUserType } = useDropdownData();
  const { sendInvitation } = useInvitationManagement();
  const { createADUser } = useGlobalUsers();
  const { user, tenant } = useUserContext();

  const [errors, setErrors] = useState({
    userType: false,
    email: false,
    firstname: false,
    lastname: false,
    roleId: false
  });

  const onChange = (event, type?) => {
    const detailType = type ? type : event?.target?.name;
    const detailValue = type ? event : event?.target?.value;

    setInviteUserDetails((prev) => ({
      ...prev,
      [detailType]: detailValue,
    }));

    // Clear error when user starts typing
    setErrors((prev) => ({ ...prev, [detailType]: detailValue.trim() === '' }));
  };

  const handleSubmit = () => {
    setLoading(true);
    const newErrors = {
      userType: inputFieldValidator(inviteUserDetails?.userType, "string"),
      email: inputFieldValidator(inviteUserDetails?.email, "email"),
      roleId: inputFieldValidator(inviteUserDetails?.email, "roleId"),
      firstname: inputFieldValidator(inviteUserDetails?.email, "string"),
      lastname: inputFieldValidator(inviteUserDetails?.email, "string"),
    };

    setErrors(newErrors);

    const hasError = Object.values(newErrors).some((v) => v);
    if (hasError) return setLoading(false);

    const obj = {
      userEmail: inviteUserDetails?.email,
      invitedTo: "",
      invitedFromTenantId: tenant?.id,
      invitedFromTenantName: tenant?.name,
      invitedFromGlobalUserId: user?.userId,
      invitationSendOn: new Date(),
      invitationReSendOn: null,
      userTypeId: inviteUserDetails?.userType,
      roleId: inviteUserDetails?.roleId
    };

    const mailObj = {
      firstName: inviteUserDetails?.firstname,
      lastName: inviteUserDetails?.lastname,
      email: inviteUserDetails?.email,
      displayName: `${inviteUserDetails?.firstname} ${inviteUserDetails?.lastname}`,
    }

    sendInvitation(obj)
      .then((res) => {
        createADUser(mailObj).then((res) => {
          if (res?.status && res?.status !== 200) {
            toast.error("Invitation sent but failed to create AD user. Please contact support.");
            setLoading(false);
            return;
          }

          toast.success("User Invitation Sent");
          setInviteUserDetails({
            userType: undefined,
            roleId: undefined,
            email: undefined,
            firstname: undefined,
            lastname: undefined,
          });
          handleClose();
          setLoading(false)
          props.successCallBack();
        }).catch((err) => {
          handleClose();
          setLoading(false)
          toast.error(err?.response?.data?.Message);
        });
      })
      .catch((err) => {
        handleClose();
        setLoading(false)
        toast.error(err?.response?.data?.Message);
      });
  };

  const handleClose = () => {
    setInviteUserDetails({
      userType: undefined,
      roleId: undefined,
      email: undefined,
      firstname: undefined,
      lastname: undefined,
    });
    props.setIsShow(false)
  }

  return (
    <div>
      <Sheet open={props?.isShow} onOpenChange={props.setIsShow}>
        <SheetContent side="right" className="w-full min-w-[600px] p-0 overflow-auto">
          <SheetHeader className="bg-gradient-to-r from-purple-50 to-blue-50 p-6 border-b detail-header">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="bg-purple-100 p-2 rounded-lg">
                  <User2 className="h-6 w-6 text-purple-600" />
                </div>
                <div>
                  <SheetTitle className="text-xl font-bold text-gray-900">Invite Internal Users</SheetTitle>
                  <p className="text-sm text-gray-600 mt-1">Invite users to manage the orgnization stuffs</p>
                </div>
              </div>
            </div>
            <Button variant="outline" onClick={handleClose} className="close-panel">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x h-4 w-4"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
            </Button>
          </SheetHeader>
          <div className="p-6 space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-xs font-bold">User Type</label>
                <Select
                  value={inviteUserDetails?.userType || undefined}
                  onValueChange={(event) => onChange(event, "userType")}
                >
                  <SelectTrigger
                    className={errors.userType ? "border-red-500 focus-visible:ring-red-500 w-full" : "w-full"}
                  >
                    <SelectValue placeholder="Select User Type" />
                  </SelectTrigger>
                  <SelectContent>
                    {userManagemnetUserType?.map((item, index) => {
                      return (
                        <SelectItem key={index} value={item?.id}>
                          {item?.name}
                        </SelectItem>
                      );
                    })}
                  </SelectContent>
                </Select>
              </div>

              <div>
                <label className="text-xs font-bold">User Role</label>
                <Select
                  value={inviteUserDetails?.roleId || undefined}
                  onValueChange={(event) => onChange(event, "roleId")}
                >
                  <SelectTrigger
                    className={errors.userType ? "border-red-500 focus-visible:ring-red-500 w-full" : "w-full"}
                  >
                    <SelectValue placeholder="Select User Type" />
                  </SelectTrigger>
                  <SelectContent>
                    {props?.roles?.map((item, index) => {
                      return (
                        <SelectItem key={index} value={item?.id}>
                          {item?.roleName}
                        </SelectItem>
                      );
                    })}
                  </SelectContent>
                </Select>
              </div>

              <div>
                <label className="text-xs font-bold">First Name</label>
                <Input
                  type="text"
                  placeholder="firstname"
                  className={errors.firstname ? "border-red-500 focus-visible:ring-red-500 w-full" : "w-full"}
                  name="firstname"
                  onChange={(event) => onChange(event)}
                />
              </div>

              <div>
                <label className="text-xs font-bold">Last Name</label>
                <Input
                  type="text"
                  placeholder="lastname"
                  className={errors.lastname ? "border-red-500 focus-visible:ring-red-500 w-full" : "w-full"}
                  name="lastname"
                  onChange={(event) => onChange(event)}
                />
              </div>

              <div>
                <label className="text-xs font-bold">Email</label>
                <Input
                  type="email"
                  placeholder="Email"
                  className={errors.email ? "border-red-500 focus-visible:ring-red-500 w-full" : "w-full"}
                  name="email"
                  onChange={(event) => onChange(event)}
                />
              </div>
            </div>

            <SheetFooter>
              {/* Footer Actions */}
              <div className="absolute bottom-0 left-0 right-0 px-6 py-4 border-t border-border bg-card flex justify-end gap-3">
                <Button
                  type="submit"
                  onClick={handleSubmit}
                  disabled={loading}
                  className="bg-primary text-primary-foreground hover:bg-primary/90"
                >
                  {loading ? (
                    <>
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      Inviting...
                    </>
                  ) : (
                    "Invite User"
                  )}
                </Button>
              </div>
            </SheetFooter>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default InviteUser;
